// extracted by mini-css-extract-plugin
module.exports = {"h5NavLink":"FooterH5_h5NavLink__5ctzx","navLink":"FooterH5_navLink___Oeq2","footerData":"FooterH5_footerData__AUSmS"};